import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useGetQuery, usePostQuery } from 'hooks'
import { Box, Button, Card, Checkbox, Input, Table } from 'components'

const emptyFlag = { key: '', name: '', description: '' }

export const AdminFeatureFlags = () => {
  const { data, refetch } = useGetQuery({ url: '/admin/feature_flags' })
  const { post: createFlag } = usePostQuery({ url: '/admin/feature_flags' })
  const { post: updateFlag } = usePostQuery({ method: 'PUT' })
  const { post: deleteFlag } = usePostQuery({ method: 'DELETE' })

  const [newFlag, setNewFlag] = useState(emptyFlag)

  const rows = data?.feature_flags || []

  const addFlag = () => {
    if (!newFlag.key || !newFlag.name) return
    createFlag(newFlag).then(() => {
      setNewFlag(emptyFlag)
      refetch(true)
    })
  }

  const toggleEnabled = (flag, enabled) => {
    updateFlag({ enabled }, `/admin/feature_flags/${flag.id}`).then(() => refetch(true))
  }

  const removeFlag = (flag) => {
    deleteFlag({}, `/admin/feature_flags/${flag.id}`).then(() => refetch(true))
  }

  return (
    <Card>
      <Box css="display:flex;align-items:center;gap:0.4rem;margin:0.5rem 1rem;">
        <Input name="new-flag-key" placeholder="key" value={newFlag.key} onChange={(e) => setNewFlag((prev) => ({ ...prev, key: e.target.value }))} />
        <Input name="new-flag-name" placeholder="name" value={newFlag.name} onChange={(e) => setNewFlag((prev) => ({ ...prev, name: e.target.value }))} />
        <Input name="new-flag-description" placeholder="description" value={newFlag.description} onChange={(e) => setNewFlag((prev) => ({ ...prev, description: e.target.value }))} />
        <Button onPress={addFlag}>Add flag</Button>
      </Box>

      <Table
        data={rows}
        columns={[
          { title: 'Key', key: 'key' },
          { title: 'Name', key: 'name' },
          {
            title: 'Enabled',
            key: 'enabled',
            render: (enabled, _i, row) => (
              <Checkbox name={`enabled-${row.id}`} checked={enabled} onChange={(e) => toggleEnabled(row, e.target.checked)} />
            )
          },
          {
            title: 'Action',
            key: 'id',
            className: 'right',
            render: (id, _i, row) => (
              <Box css="display:flex;gap:0.4rem;justify-content:flex-end;">
                <Link to={`/admin/feature_flags/${id}`}>
                  <Button>Manage</Button>
                </Link>
                <Button onPress={() => removeFlag(row)}>Delete</Button>
              </Box>
            )
          }
        ]}
      />
    </Card>
  )
}
